import {
  GROUP_GET_LIST_REQUEST,
  GROUP_GET_LIST_SUCCESS,
  GROUP_GET_LIST_FAIL,
  GROUP_GET_BY_ID_REQUEST,
  GROUP_GET_BY_ID_SUCCESS,
  GROUP_GET_BY_ID_FAIL,
  GROUP_CREATE_REQUEST,
  GROUP_CREATE_SUCCESS,
  GROUP_CREATE_FAIL,
  GROUP_SEND_MESSAGE_REQUEST,
  GROUP_SEND_MESSAGE_SUCCESS,
  GROUP_SEND_MESSAGE_FAIL,
  GROUP_VOICE_UPLOAD_COMPLETE,
  GROUP_NEW_MESSAGE,
  GROUP_SELECT,
  GROUP_LEAVE_ROOM,
  GROUP_RESET,
  GROUP_ADD_MEMBER_SUCCESS,
  GROUP_REMOVE_MEMBER_SUCCESS,
  GROUP_SET_ADMIN_SUCCESS,
  GROUP_ADD_TOPIC_SUCCESS,
  GROUP_UPDATE_TOPIC_SUCCESS,
  GROUP_DELETE_TOPIC_SUCCESS,
  GROUP_DELETE_MESSAGE_SUCCESS,
  GROUP_BULK_DELETE_MESSAGES_SUCCESS,
  GROUP_LEAVE_SUCCESS,
  GROUP_PIN_MESSAGE_SUCCESS,
  GROUP_UNPIN_MESSAGE_SUCCESS,
  GROUP_EDIT_MESSAGE_SUCCESS,
  GROUP_SET_SELECTED_TOPIC,
  GROUP_CALL_ACTIVE,
  GROUP_CALL_ENDED,
  GROUP_SET_UNREAD_COUNTS,
  GROUP_BULK_MARK,
  GROUP_BULK_MUTE,
  GROUP_BULK_REMOVE,
  GROUP_MARK_SEEN,
  GROUP_REMOTE_SEEN,
  GROUP_MESSAGE_REACTION,
  GROUP_TOGGLE_PUBLIC_SUCCESS,
  GROUP_GENERATE_LINK_SUCCESS,
  GROUP_PREVIEW_BY_LINK_REQUEST,
  GROUP_PREVIEW_BY_LINK_SUCCESS,
  GROUP_PREVIEW_BY_LINK_FAIL,
  GROUP_JOIN_BY_LINK_SUCCESS,
  GROUP_JOIN_REQUESTS_SUCCESS,
  GROUP_PROCESS_JOIN_REQUEST_SUCCESS,
  GROUP_UPDATE_INFO_SUCCESS,
  GROUP_LOAD_OLDER_MESSAGES_REQUEST,
  GROUP_LOAD_OLDER_MESSAGES_SUCCESS,
  GROUP_LOAD_OLDER_MESSAGES_FAIL,
} from "./groupChatTypes";

const initialState = {
  items: [],
  pagination: { page: 1, limit: 20, total: 0, pages: 0 },
  currentGroup: null,
  activeGroupId: null,
  selectedTopicId: null,
  loadingList: false,
  loadingGroup: false,
  loadingOlderMessages: false,
  messagesPagination: null,
  sendingMessage: false,
  error: null,
  unreadByGroupId: {},
  /** Active group calls: one per topic. Array of { groupId, topicId, roomName, callType, startedBy, startedByName } */
  activeGroupCalls: [],
  groupPreview: null,
  loadingPreview: false,
  joinRequests: [],
};

export const groupChatReducer = (state = initialState, action) => {
  switch (action.type) {
    case GROUP_GET_LIST_REQUEST:
      return { ...state, loadingList: true, error: null };
    case GROUP_GET_LIST_SUCCESS: {
      const { items, pagination } = action.payload?.body ?? {};
      return {
        ...state,
        loadingList: false,
        items: items ?? state.items,
        pagination: pagination ?? state.pagination,
        error: null,
      };
    }
    case GROUP_GET_LIST_FAIL:
      return { ...state, loadingList: false, error: action.payload };

    case GROUP_GET_BY_ID_REQUEST:
      return { ...state, loadingGroup: true, loadingOlderMessages: false, error: null };
    case GROUP_GET_BY_ID_SUCCESS: {
      const group = action.payload?.body?.group ?? null;
      const messagesPagination = action.payload?.body?.messagesPagination ?? state.messagesPagination;
      const nextActiveGroupId =
        group?._id != null ? group._id : state.activeGroupId;
      return {
        ...state,
        loadingGroup: false,
        currentGroup: group,
        messagesPagination,
        activeGroupId: nextActiveGroupId,
        error: null,
      };
    }
    case GROUP_GET_BY_ID_FAIL:
      return { ...state, loadingGroup: false, error: action.payload };

    case GROUP_LOAD_OLDER_MESSAGES_REQUEST:
      return { ...state, loadingOlderMessages: true, error: null };
    case GROUP_LOAD_OLDER_MESSAGES_SUCCESS: {
      const groupId = action.payload?._groupId;
      if (groupId && String(state.activeGroupId) !== String(groupId)) {
        return { ...state, loadingOlderMessages: false };
      }
      const { group, messagesPagination } = action.payload?.body ?? {};
      const olderMessages = group?.Messages ?? [];
      const existingMessages = state.currentGroup?.Messages ?? [];
      const existingIds = new Set(existingMessages.map((m) => String(m._id)));
      const dedupedOlder = olderMessages.filter(
        (m) => !existingIds.has(String(m._id)),
      );
      const merged = [...dedupedOlder, ...existingMessages];
      return {
        ...state,
        loadingOlderMessages: false,
        currentGroup: {
          ...state.currentGroup,
          Messages: merged,
        },
        messagesPagination: messagesPagination ?? state.messagesPagination,
        error: null,
      };
    }
    case GROUP_LOAD_OLDER_MESSAGES_FAIL:
      return { ...state, loadingOlderMessages: false, error: action.payload };

    case GROUP_CREATE_REQUEST:
      return { ...state, error: null };
    case GROUP_CREATE_SUCCESS: {
      const group = action.payload?.body?.group;
      if (!group) return state;
      const exists = state.items.some(
        (g) => String(g._id) === String(group._id),
      );
      return {
        ...state,
        items: exists ? state.items : [group, ...state.items],
        currentGroup: group,
        activeGroupId: group._id,
        error: null,
      };
    }
    case GROUP_CREATE_FAIL:
      return { ...state, error: action.payload };

    case GROUP_SEND_MESSAGE_REQUEST: {
      const { tempMessage, groupId } = action.payload || {};
      if (!tempMessage || !groupId || !state.currentGroup) {
        return { ...state, sendingMessage: true };
      }
      const gid = String(groupId);
      if (String(state.currentGroup._id) !== gid) {
        return { ...state, sendingMessage: true };
      }
      const messages = [...(state.currentGroup.Messages || []), tempMessage];
      return {
        ...state,
        sendingMessage: true,
        currentGroup: { ...state.currentGroup, Messages: messages },
      };
    }
    case GROUP_SEND_MESSAGE_SUCCESS: {
      const body = action.payload?.body;
      const groupId = body?.groupId;
      const message = body?.message;
      const tempId = action.payload?._optimisticTempId;
      if (!groupId || !message) return { ...state, sendingMessage: false };
      const gid = String(groupId);
      const isActive = String(state.activeGroupId) === gid;
      const oldMessages = isActive && state.currentGroup?.Messages
        ? state.currentGroup.Messages
        : [];
      const tempIndex = tempId
        ? oldMessages.findIndex((m) => String(m._id) === String(tempId))
        : -1;
      const messages =
        tempIndex >= 0
          ? oldMessages.map((m, i) =>
              i === tempIndex ? { ...message } : m,
            )
          : isActive
            ? [...oldMessages, message]
            : state.currentGroup?.Messages;
      const currentGroup =
        isActive && state.currentGroup
          ? {
              ...state.currentGroup,
              Messages: messages ?? [message],
              DefineTime: message.CreatedAt,
            }
          : state.currentGroup;
      const updatedItems = state.items.map((g) =>
        String(g._id) === gid
          ? { ...g, Messages: [message], DefineTime: message.CreatedAt }
          : g,
      );
      return {
        ...state,
        sendingMessage: false,
        currentGroup: currentGroup ?? state.currentGroup,
        items: updatedItems.length ? updatedItems : state.items,
      };
    }
    case GROUP_SEND_MESSAGE_FAIL: {
      const errorMsg = action.payload?.error ?? action.payload;
      const tempId = action.payload?.tempId;
      if (!tempId || !state.currentGroup) {
        return { ...state, sendingMessage: false, error: errorMsg };
      }
      const messages = (state.currentGroup.Messages || []).map((m) =>
        String(m._id) === String(tempId)
          ? { ...m, _status: "failed", _errorMessage: errorMsg }
          : m,
      );
      return {
        ...state,
        sendingMessage: false,
        currentGroup: { ...state.currentGroup, Messages: messages },
        error: errorMsg,
      };
    }

    case GROUP_VOICE_UPLOAD_COMPLETE: {
      const { tempId, remoteUrl, groupId } = action.payload || {};
      if (!tempId || !state.currentGroup) return state;
      if (groupId && String(state.currentGroup._id) !== String(groupId))
        return state;
      const messages = (state.currentGroup.Messages || []).map((m) =>
        String(m._id) === String(tempId)
          ? {
              ...m,
              _status: "sending",
              Attachments: [remoteUrl],
              MessageAttachs: [remoteUrl],
            }
          : m,
      );
      return {
        ...state,
        currentGroup: { ...state.currentGroup, Messages: messages },
      };
    }

    case GROUP_NEW_MESSAGE: {
      const { groupId, message } = action.payload ?? {};
      if (!groupId || !message) return state;
      const gid = String(groupId);
      const isActive = String(state.activeGroupId) === gid;
      if (isActive && state.currentGroup?.Messages) {
        const alreadyExists = state.currentGroup.Messages.some(
          (m) => String(m._id) === String(message._id),
        );
        if (alreadyExists) return state;
      }
      const messages =
        isActive && state.currentGroup?.Messages
          ? [...state.currentGroup.Messages, message]
          : state.currentGroup?.Messages;
      const currentGroup =
        isActive && state.currentGroup
          ? {
              ...state.currentGroup,
              Messages: messages ?? [message],
              DefineTime: message.CreatedAt,
            }
          : state.currentGroup;
      const updatedItems = state.items.map((g) =>
        String(g._id) === gid
          ? { ...g, Messages: [message], DefineTime: message.CreatedAt }
          : g,
      );
      const unreadByGroupId = { ...state.unreadByGroupId };
      if (!isActive) unreadByGroupId[gid] = (unreadByGroupId[gid] || 0) + 1;
      return {
        ...state,
        currentGroup: currentGroup ?? state.currentGroup,
        items: updatedItems.length ? updatedItems : state.items,
        unreadByGroupId,
      };
    }

    case GROUP_MARK_SEEN:
      return state;

    case GROUP_REMOTE_SEEN: {
      const { groupId, userId, seen } = action.payload ?? {};
      if (
        !state.currentGroup ||
        !userId ||
        String(state.currentGroup._id) !== String(groupId)
      )
        return state;
      const messages = (state.currentGroup.Messages || []).map((m) => {
        const seenBy = Array.isArray(m.SeenBy) ? [...m.SeenBy] : [];
        const hasUser = seenBy.some((id) => String(id) === String(userId));
        if (hasUser) return m;
        const applyToThis =
          seen === "all" ||
          (Array.isArray(seen) &&
            seen.some((id) => String(id) === String(m._id)));
        if (!applyToThis) return m;
        return { ...m, SeenBy: [...seenBy, userId] };
      });
      return {
        ...state,
        currentGroup: { ...state.currentGroup, Messages: messages },
      };
    }

    case GROUP_MESSAGE_REACTION: {
      const { groupId, messageId, reactions } = action.payload ?? {};
      if (
        !state.currentGroup ||
        !messageId ||
        !Array.isArray(reactions) ||
        String(state.currentGroup._id) !== String(groupId)
      )
        return state;
      const messages = (state.currentGroup.Messages || []).map((m) =>
        String(m._id) !== String(messageId)
          ? m
          : { ...m, Reactions: reactions },
      );
      return {
        ...state,
        currentGroup: { ...state.currentGroup, Messages: messages },
      };
    }

    case GROUP_SELECT: {
      const groupId = action.payload ?? null;
      const unreadByGroupId = { ...state.unreadByGroupId };
      if (groupId) unreadByGroupId[String(groupId)] = 0;
      return { ...state, activeGroupId: groupId, unreadByGroupId, loadingOlderMessages: false };
    }
    case GROUP_SET_UNREAD_COUNTS: {
      const incoming = action.payload || {};
      const activeKey = state.activeGroupId ? String(state.activeGroupId) : null;
      const merged = { ...state.unreadByGroupId, ...incoming };
      if (activeKey && merged[activeKey] !== 0 && incoming[activeKey] != null) {
        merged[activeKey] = 0;
      }
      return { ...state, unreadByGroupId: merged };
    }

    case GROUP_BULK_MARK: {
      const { groupIds = [], read = true } = action.payload || {};
      const unreadByGroupId = { ...state.unreadByGroupId };
      if (read) {
        groupIds.forEach((id) => {
          unreadByGroupId[String(id)] = 0;
        });
      }
      return { ...state, unreadByGroupId };
    }
    case GROUP_BULK_MUTE: {
      const { groupIds = [], mute = true } = action.payload || {};
      const idSet = new Set(groupIds.map((id) => String(id)));
      const items = (state.items || []).map((g) =>
        idSet.has(String(g._id)) ? { ...g, Muted: mute, IsMuted: mute } : g,
      );
      return { ...state, items };
    }
    case GROUP_BULK_REMOVE: {
      const { groupIds = [] } = action.payload || {};
      const idSet = new Set(groupIds.map((id) => String(id)));
      const items = (state.items || []).filter(
        (g) => !idSet.has(String(g._id)),
      );
      const unreadByGroupId = { ...state.unreadByGroupId };
      groupIds.forEach((id) => {
        delete unreadByGroupId[String(id)];
      });
      return { ...state, items, unreadByGroupId };
    }

    case GROUP_LEAVE_ROOM:
      return state;

    case GROUP_ADD_MEMBER_SUCCESS:
    case GROUP_REMOVE_MEMBER_SUCCESS:
    case GROUP_SET_ADMIN_SUCCESS: {
      const group = action.payload?.body?.group;
      if (!group) return state;
      const gid = String(group._id);
      const isCurrent = String(state.activeGroupId) === gid;
      return {
        ...state,
        currentGroup: isCurrent ? group : state.currentGroup,
        items: state.items.map((g) => (String(g._id) === gid ? group : g)),
      };
    }

    case GROUP_ADD_TOPIC_SUCCESS:
    case GROUP_UPDATE_TOPIC_SUCCESS:
    case GROUP_DELETE_TOPIC_SUCCESS: {
      const body = action.payload?.body;
      const Topics = body?.Topics ?? body?.group?.Topics;
      const groupId = body?.groupId ?? state.activeGroupId;
      if (!groupId || !Topics) return state;
      const gid = String(groupId);
      const isCurrent = String(state.activeGroupId) === gid;
      const currentGroup =
        isCurrent && state.currentGroup
          ? { ...state.currentGroup, Topics }
          : state.currentGroup;
      const items = state.items.map((g) =>
        String(g._id) === gid ? { ...g, Topics } : g,
      );
      return {
        ...state,
        currentGroup: currentGroup ?? state.currentGroup,
        items,
      };
    }

    case GROUP_DELETE_MESSAGE_SUCCESS: {
      const body = action.payload?.body;
      const groupId = body?.groupId;
      const messageId = body?.messageId;
      const hard = body?.hard;
      if (
        !state.currentGroup ||
        !groupId ||
        String(state.currentGroup._id) !== String(groupId)
      )
        return state;
      const messages = hard
        ? (state.currentGroup.Messages || []).filter(
            (m) => String(m._id) !== String(messageId),
          )
        : (state.currentGroup.Messages || []).map((m) =>
            String(m._id) === String(messageId)
              ? { ...m, IsDeleted: true, Text: "" }
              : m,
          );
      const pinned = hard
        ? (state.currentGroup.PinnedMessageIds || []).filter(
            (id) => String(id) !== String(messageId),
          )
        : state.currentGroup.PinnedMessageIds;
      return {
        ...state,
        currentGroup: {
          ...state.currentGroup,
          Messages: messages,
          PinnedMessageIds: pinned,
        },
      };
    }

    case GROUP_BULK_DELETE_MESSAGES_SUCCESS: {
      const body = action.payload?.body;
      const groupId = body?.groupId;
      const ids = (body?.deletedIds ?? []).map((id) => String(id));
      const hard = body?.hard;
      if (
        !state.currentGroup ||
        !ids.length ||
        String(state.currentGroup._id) !== String(groupId)
      )
        return state;
      const messages = hard
        ? (state.currentGroup.Messages || []).filter(
            (m) => !ids.includes(String(m._id)),
          )
        : (state.currentGroup.Messages || []).map((m) =>
            ids.includes(String(m._id))
              ? { ...m, IsDeleted: true, Text: "" }
              : m,
          );
      const pinned = hard
        ? (state.currentGroup.PinnedMessageIds || []).filter(
            (id) => !ids.includes(String(id)),
          )
        : state.currentGroup.PinnedMessageIds;
      return {
        ...state,
        currentGroup: {
          ...state.currentGroup,
          Messages: messages,
          PinnedMessageIds: pinned,
        },
      };
    }
    case GROUP_PIN_MESSAGE_SUCCESS:
    case GROUP_UNPIN_MESSAGE_SUCCESS: {
      const body = action.payload?.body;
      const groupId = body?.groupId;
      const pinned = body?.PinnedMessageIds ?? [];
      if (
        !state.currentGroup ||
        String(state.currentGroup._id) !== String(groupId)
      )
        return state;
      return {
        ...state,
        currentGroup: { ...state.currentGroup, PinnedMessageIds: pinned },
      };
    }

    case GROUP_EDIT_MESSAGE_SUCCESS: {
      const body = action.payload?.body;
      const groupId = body?.groupId;
      const messageId = body?.messageId;
      const text = body?.text;
      if (
        !state.currentGroup ||
        !messageId ||
        text == null ||
        String(state.currentGroup._id) !== String(groupId)
      )
        return state;
      const now = Date.now();
      const messages = (state.currentGroup.Messages || []).map((m) =>
        String(m._id) === String(messageId)
          ? { ...m, Text: text, UpdatedAt: now }
          : m,
      );
      return {
        ...state,
        currentGroup: { ...state.currentGroup, Messages: messages },
      };
    }

    case GROUP_LEAVE_SUCCESS: {
      const groupId = action.payload?.body?.groupId;
      if (!groupId) return state;
      const gid = String(groupId);
      const items = state.items.filter((g) => String(g._id) !== gid);
      const currentGroup =
        String(state.currentGroup?._id) === gid ? null : state.currentGroup;
      const activeGroupId =
        String(state.activeGroupId) === gid ? null : state.activeGroupId;
      const unreadByGroupId = { ...state.unreadByGroupId };
      delete unreadByGroupId[gid];
      return { ...state, items, currentGroup, activeGroupId, unreadByGroupId };
    }

    case GROUP_SET_SELECTED_TOPIC:
      return { ...state, selectedTopicId: action.payload ?? null };

    case GROUP_CALL_ACTIVE: {
      const call = action.payload;
      if (!call?.groupId || !call?.roomName) return state;
      const key = (g, t) => `${g}-${t ?? "general"}`;
      const newKey = key(String(call.groupId), call.topicId);
      const list = (state.activeGroupCalls ?? []).filter(
        (c) => key(String(c.groupId), c.topicId) !== newKey,
      );
      return { ...state, activeGroupCalls: [...list, call] };
    }
    case GROUP_CALL_ENDED: {
      const payload = action.payload;
      if (!payload?.groupId) return state;
      const list = (state.activeGroupCalls ?? []).filter((c) => {
        if (String(c.groupId) !== String(payload.groupId)) return true;
        const matchTopic =
          payload.topicId == null ? c.topicId == null : String(c.topicId) === String(payload.topicId);
        return !matchTopic;
      });
      return { ...state, activeGroupCalls: list };
    }

    case GROUP_TOGGLE_PUBLIC_SUCCESS: {
      const group = action.payload?.body?.group;
      if (!group) return state;
      return {
        ...state,
        currentGroup: state.currentGroup && String(state.currentGroup._id) === String(group._id) ? group : state.currentGroup,
        items: state.items.map((g) => String(g._id) === String(group._id) ? { ...g, IsPublic: group.IsPublic, JoinLink: group.JoinLink } : g),
      };
    }
    case GROUP_GENERATE_LINK_SUCCESS: {
      const { groupId, joinLink } = action.payload?.body || {};
      if (!groupId) return state;
      return {
        ...state,
        currentGroup: state.currentGroup && String(state.currentGroup._id) === String(groupId) ? { ...state.currentGroup, JoinLink: joinLink } : state.currentGroup,
      };
    }
    case GROUP_PREVIEW_BY_LINK_REQUEST:
      return { ...state, loadingPreview: true, groupPreview: null };
    case GROUP_PREVIEW_BY_LINK_SUCCESS:
      return { ...state, loadingPreview: false, groupPreview: action.payload?.body || null };
    case GROUP_PREVIEW_BY_LINK_FAIL:
      return { ...state, loadingPreview: false, groupPreview: null };
    case GROUP_JOIN_BY_LINK_SUCCESS:
      return state;
    case GROUP_JOIN_REQUESTS_SUCCESS:
      return { ...state, joinRequests: action.payload?.body?.requests || [] };
    case GROUP_PROCESS_JOIN_REQUEST_SUCCESS:
      return {
        ...state,
        joinRequests: state.joinRequests.filter((r) => String(r._id) !== String(action.payload?.body?.requestId)),
        currentGroup: action.payload?.body?.group || state.currentGroup,
      };
    case GROUP_UPDATE_INFO_SUCCESS: {
      const group = action.payload?.body?.group;
      if (!group) return state;
      return {
        ...state,
        currentGroup: state.currentGroup && String(state.currentGroup._id) === String(group._id) ? group : state.currentGroup,
        items: state.items.map((g) => String(g._id) === String(group._id) ? { ...g, Name: group.Name, Description: group.Description } : g),
      };
    }

    case GROUP_RESET:
      return initialState;

    default:
      return state;
  }
};
